<template>
  <div>
    <h3>im-通话记录管理</h3>
    <el-form
      ref="formIM"
      :model="formIM"
      size="mini"
      :inline="true"
      label-width="100px"
    >
      <el-form-item label="甲方昵称">
        <el-input
          v-model="formIM.nickNameA"
          placeholder="请输入甲方昵称"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="甲方手机号">
        <el-input
          v-model.trim="formIM.phoneA"
          placeholder="请输入甲方手机号"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="乙方昵称">
        <el-input
          v-model="formIM.nickNameB"
          placeholder="请输入乙方昵称"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="乙方手机号">
        <el-input
          v-model.trim="formIM.phoneB"
          placeholder="请输入乙方手机号"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="fetch()" size="mini">查询</el-button>
        <el-button @click="reset()" size="mini">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="list" size="mini" style="width: 100%" v-loading="loading">
      <el-table-column
        prop="nickNameA"
        width="160px"
        label="甲方昵称"
      ></el-table-column>

      <el-table-column prop="phoneA" width="120px" label="甲方手机号" />
      <el-table-column prop="nickNameB" width="160px" label="乙方昵称" />
      <el-table-column prop="phoneB" width="120px" label="乙方手机号" />
      <el-table-column prop="type" show-overflow-tooltip label="关联职位名">
        <template slot-scope="scope">
          <span
            class="text"
            v-if="scope.row.jobTitle"
            @click="handleJobs(scope.row)"
            >{{ scope.row.jobTitle }}</span
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="entityId" show-overflow-tooltip label="关联技能名">
        <template slot-scope="scope">
          <span
            class="text"
            v-if="scope.row.serviceTitle"
            @click="handleMsgs(scope.row)"
            >{{ scope.row.serviceTitle }}</span
          >
          <span v-else> - </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="callCreateTime"
        width="180px"
        label="通话创建时间"
      />
      <!-- <el-table-column prop="callDuration" width="140px" label="通话时长(秒)" /> -->
      <el-table-column prop="callDurationStr" width="140px" label="通话时长">
        <template slot-scope="scope">
          {{
            scope.row.callDurationStr != 0 ? scope.row.callDurationStr : ""
          }}</template
        >
      </el-table-column>
      <el-table-column prop="callUrl" width="120px" label="通话内容下载">
        <template slot-scope="scope">
          <a
            v-if="scope.row.callUrl"
            href=""
            @click="inkBlank(scope.row.callUrl)"
            >下载</a
          >
        </template>
      </el-table-column>
    </el-table>

    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import map from "../../datamap";
import api from "../api";
const { callInfo } = api;
export default {
  name: "imCallMange",
  data() {
    return {
      map,
      formIM: {
        partyA: "",
        nickNameA: "",
        phoneA: "",
        nickNameB: "",
        phoneB: "",
      },
      list: [],
      loading: true,
      limit: 20,
      pageNum: 1,
      total: 0,
      isSubmiting: false,
    };
  },
  watch: {
    pageNum() {
      this.fetch(2);
    },
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;

      let { partyA, nickNameA, phoneA, nickNameB, phoneB } = this.formIM;
      let obj = {
        pageNum: pageNum,
        limit: limit,
        nickNameA: nickNameA,
        phoneA: phoneA,
        nickNameB: nickNameB,
        phoneB: phoneB,
      };

      let res = await callInfo.list(obj);

      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    reset() {
      this.pageNum = 1;
      this.formIM = {};
      this.fetch();
    },
    // 关联职位名
    handleJobs(row) {
      this.$router.push({ path: "/jobs", query: { jobTitle: row.jobTitle } });
      //
    },
    // 关联技能名-跳转会话
    handleMsgs(row) {
      this.$router.push({
        path: "/msgs",
        query: {
          sessionId: row.conversationId,
          partyA: "",
          partyB: "",
        },
      });
    },

    inkBlank(row) {
      //直接跳转一个新页面下载，浏览器会预览
      let _href = document.createElement("a"); // 创建A标签
      _href.href = row; // 下载地址
      _href.target = "_blank";
      document.body.appendChild(_href);
      _href.click(); // 模拟点击A标签
      document.body.removeChild(_href); // 下载完成移除元素
    },
  },
};
</script>

<style scoped>
.text {
  color: #1ab394;
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/views/imCallMange/index.vue